<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Assinaturas Ativas Sem Recorrência"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getRecurrenceIsNullTable"
  emptyMessage="Sem mais recorrências nulas no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [dropdownFilters]="dropdownFilters"
  [defaultRows]="15"
  [changeColumns]="true"
  [multiSelectFilter]="true"
  *ngIf="dropdownFilters"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
